import type { ContentObject } from 'models';
import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useUpdateGivingLike } from 'features/givings/hooks';
import { patchContentObjectLike } from '../utils';

export type UpdateLikeProperties = {
  action: 'like' | 'unlike';
};

/**
 * @deprecated Contains unimplemented 'event' and 'video' branches that throw at runtime instead of updating the like cache. Fix before relying on this for event or video content objects.
 */
export const useUpdateLike = ({ action }: UpdateLikeProperties) => {
  const cache = useContentObjectCache();
  const updateGivingLike = useUpdateGivingLike();

  return useCallback(
    ({ contentObject }: { contentObject: ContentObject }) => {
      // These call genuinely different mutations/backends (e.g. a separate giving detail cache, or an
      // unimplemented event/video/comment like API), not different cache logic, so they stay separate.
      switch (contentObject.type) {
        case 'activity':
          throw new Error('Activity cannot be liked');
        case 'event':
          // TODO: Implement event cache like logic
          throw new Error('Not implemented');
        case 'video':
          // TODO: Implement video cache like logic
          throw new Error('Not implemented');
        case 'comment':
          // TODO: Implement comment cache like logic
          throw new Error('Not implemented');
        case 'giving':
          updateGivingLike({ action, contentObject });
          return;
        case 'kudo':
        case 'poll':
        case 'post':
        case 'withings_order_post':
          break;
      }

      cache.patch(contentObject, (item) => patchContentObjectLike(item, action));
    },
    [action, cache, updateGivingLike],
  );
};
